export default function Welcome () {
  throw new Error("testing")
}
